/**
 * External dependencies
 */
import React from 'react';

/**
 * Internal dependencies
 */

const NumberChart = () => {
	return (
		<svg width='24' height='24' viewBox='0 0 80 80'>
			<circle fill='none' stroke='#fea58e' strokeWidth='6' cx='39' cy='39' r='36'></circle>
			<path
				fill='#51d3d9'
				d='M37.4,56.7V34.9H29v-5.1c1.2,0,2.3-0.1,3.4-0.3c1.1-0.2,2.1-0.6,3-1.1s1.6-1.2,2.2-2.1c0.6-0.9,1-1.9,1.2-3.2h5.4v33.6H37.4z'
			></path>
		</svg>
	);
};

export default NumberChart;
